import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class Items extends Component {
  static defaultProps = {
    items: []
  }

  static propTypes = {
    items: PropTypes.array.isRequired
  }

  render () {
    return (
      <ul className='breadcrumbs'>
        {
          this.props.items.map((breadcrumb, index) => (
            <li key={index} className={`breadcrumbs__item ${breadcrumb.isActive ? 'is-active' : ''}`}>
              {
                breadcrumb.isLink
                  ? <a className='breadcrumbs__item-link' {...breadcrumb.props}>{breadcrumb.text}</a>
                  : <span>{breadcrumb.text}</span>
              }
            </li>
          ))
        }
      </ul>
    )
  }
}
